<template>
    <FormControl label="Type">
        <TextInput
            disabled
            :value="
                Service.getSchedulingStrategyLabel(service.schedulingStrategy)
            "
        />
    </FormControl>

    <FormControl label="Maximum number of seats (up to 50)">
        <TextInput
            disabled
            :value="service.maximumNumberOfSeatsPerMeeting"
        />
    </FormControl>
</template>

<script setup lang="ts">
    import { type PropType } from 'vue'
    import Service from '@/App/Service/Entity/Service'
    import FormControl from '@/Shared/Component/Forms/FormControl.vue'
    import TextInput from '@/Shared/Component/Forms/TextInput.vue'

    const props = defineProps({
        service: {
            type: Object as PropType<Service>,
            required: true,
        },
    })
</script>
